// extracted by mini-css-extract-plugin
export default {"htmlParser":"HtmlParser_htmlParser__++hXa"};